import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
  ButtonItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import uiInfo from "../../ui-info";
import {
  criarMotivoIsencaoIptuDs,
  criarNotaFiscalAvulsaDs,
  criarAgentesRecebedoresDs,
} from "../../DataSources";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  Summary,
  TotalItem,
  Editing
} from "devextreme-react/data-grid";
import {
  imprimirNotaAvulsa,
  imprimirDamsNotaAvulsa,
  abrirNotaAvulsa,
  imprimirReciboNotaAvulsa,
} from "../../lancamentosUtils";
import api from "../../api-axios";
import ShowError from "../../AppServices";
import UserInfo from "../../UserInfo";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { Button, ScrollView } from "devextreme-react";
import pixIcon from "../../images/icons/pix.png";
import { Popup, ToolbarItem } from "devextreme-react/popup";

export default class DetalheNFAvulsa extends React.Component {
  constructor(props) {
    super(props);
    this.nfDs = criarNotaFiscalAvulsaDs();
    this.saidaProgramada = false;
    this.prefeituraId = UserInfo.getPrefeitura();
    this.notaSequencial = this.props.match.params.id;
    this.state = {
      _uiModificarSituacao: { novaSituacao: "N" },
      locadIndicatorVisivel: false,
      usaPix: true,
      pixOk: false,
      pixIgnorado: false,
      _uiShowErrors: false,
      _uiErrors: []
    };

    this.baixarParcela = this.baixarParcela.bind(this);
    this.excluirBaixa = this.excluirBaixa.bind(this);
    this.modificarSituacao = this.modificarSituacao.bind(this);
    this.editar = this.editar.bind(this);
    this.reciboRetencao = this.reciboRetencao.bind(this);
    this.dam = this.dam.bind(this);
    this.confirmarPix = this.confirmarPix.bind(this);
    this.documento = this.documento.bind(this);
    this.novaSituacaoAlterada = this.novaSituacaoAlterada.bind(this);
    this.atualizarTela = this.atualizarTela.bind(this);
    this.timeoutWait = this.timeoutWait.bind(this);

    this.enumSituacoes = [
      { id: "N", descricao: "NORMAL" },
      { id: "I", descricao: "ISENTO" },
      { id: "M", descricao: "IMUNE" },
      { id: "C", descricao: "CANCELADA" },
    ];

    this.situcaoAtualOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: this.enumSituacoes,
      valueExpr: "id",
      displayExpr: "descricao",
      readOnly: true,
    };

    this.situacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: this.enumSituacoes,
      valueExpr: "id",
      displayExpr: "descricao",
      placeholder: " ",
      onValueChanged: this.novaSituacaoAlterada,
    };

    this.motivoSituacaoOptions = {
      searchEnabled: true,
      dataSource: criarMotivoIsencaoIptuDs(),
      valueExpr: "id",
      displayExpr: "descricao",
      placeholder: " ",
    };

    this.agenteRecebedorOptions = {
      searchEnabled: true,
      dataSource: criarAgentesRecebedoresDs(),
      valueExpr: "id",
      displayExpr: "descricao",
      placeholder: " ",
    };

    this.tipoMudancaSituacaoOptions = {
      dataSource: [
        { id: 1, descricao: "ISS" },
        { id: 2, descricao: "IRRF" },
        { id: 3, descricao: "ISS/IRRF" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      placeholder: " ",
    };

    this.finalizar = this.finalizar.bind(this);
    this.showErrors = this.showErrors.bind(this);
  }

  novaSituacaoAlterada(e) {
    if (e.event) {
      this.setState({ situacao: e.value });
    }
  }

  componentDidMount() {
    this.atualizarTela();
  }

  atualizarTela() {
    if (this.notaSequencial !== undefined) {
      api
        .get(
          `/nota_fiscal_avulsa/start_detalhe_nfa/${this.prefeituraId}/${this.notaSequencial}`
        )
        .then(async ({ data }) => {
          console.log("data: ", data);
          if (data && data.nf) {
            const notaAvulsa = data.nf;
            const iss = notaAvulsa.lancamentoIss;
            const irrf = notaAvulsa.lancamentoIrrf;
            const inss = notaAvulsa.lancamentoInss;

            const pixOptions = {};
            const parcelas = [];

            if (iss) {
              parcelas.push(...iss.parcelas);
            }
            if (inss) {
              parcelas.push(...inss.parcelas);
            }
            if (irrf) {
              parcelas.push(...irrf.parcelas);
            }

            try {
              if (data.usaPix && !data.pixOk) {
                this.setState({ usaPix: data.usaPix, pixOk: data.pixOk });
                let isPixLoaded = false;
                while (!isPixLoaded && !this.state.pixIgnorado) {
                  try {
                    let { data } = await api.get(
                      `/nota_fiscal_avulsa/start_detalhe_nfa/${this.prefeituraId}/${this.notaSequencial}`
                    );
                    if (data && data.pixOk && !this.state.pixIgnorado) {
                      isPixLoaded = data.pixOk;
                      pixOptions.usaPix = data.usaPix;
                      pixOptions.pixOk = data.pixOk;
                    }
                  } catch (error) {
                    ShowError(error.response);
                    notify(error, "error", 2000);
                  }
                  await this.timeoutWait();
                }
              }
            } catch (error) {
              if (error.response && error.response.data) {
                ShowError(error.response.data);
              } else {
                ShowError("Erro desconhecido");
              }
            }

            if (data && data.pixOk && !this.state.pixIgnorado) {
              pixOptions.usaPix = data.usaPix;
              pixOptions.pixOk = data.pixOk;
            }

            this.setState({
              ...notaAvulsa,
              ...pixOptions,
              _uiParcelas: parcelas,
              _uiModificarSituacao: { novaSituacao: "N" },
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            ShowError(error.response.data);
          } else {
            ShowError("Erro desconhecido");
          }
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }
  }
  timeoutWait() {
    return new Promise((resolve) => setTimeout(resolve, 2000));
  }

  render() {

    if (this.state.locadIndicatorVisivel && this.state.loadIndicatorMessage) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>

          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
              gap: "25px",
            }}
          >
            <LoadIndicator width={60} height={60} />

            <h3 style={{ display: !this.state.locadIndicatorVisivel ? "" : "none", }} >
              {this.state.loadIndicatorMessage}
            </h3>

          </div>
        </div>
      );
    }


    if (this.state.locadIndicatorVisivel || (this.state.usaPix && !this.state.pixOk)) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>

          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
              gap: "25px",
            }}
          >
            <LoadIndicator width={60} height={60} />

            <h3
              style={{
                display: this.state.locadIndicatorVisivel ? "" : "none",
              }}
            >
              Consultando Pagamento Pix
            </h3>
            <h3
              style={{
                display: !this.state.locadIndicatorVisivel ? "" : "none",
              }}
            >
              Consultando Dados
            </h3>

          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              width={120}
              text="Ignorar PIX"
              onClick={() =>
                this.setState({ usaPix: false, pixIgnorado: true })
              }
              disabled={!this.state.usaPix}
              visible={!this.state.locadIndicatorVisivel}
            />

            <Button
              width={250}
              text="Cancelar Consulta"
              onClick={() =>
                this.setState({ locadIndicatorVisivel: false, consultandoPagamento: false })
              }
              disabled={!this.state.usaPix}
              visible={this.state.locadIndicatorVisivel}
            />
          </div>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Toolbar>
            <Item
              location="left"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Voltar",
                icon: "arrowleft",
                onClick: () => this.props.history.goBack(),
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Finalizar",
                icon: "check",
                width: 150,
                onClick: () => this.finalizar()
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Logs ADN",
                icon: "comment",
                width: 150,
                onClick: () => this.showErrors()
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "DAM",
                icon: "exportpdf",
                width: 150,
                onClick: this.dam,
                visible: this.state.usaPix ? false : true,
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "DAM Pix",
                icon: pixIcon,
                width: 150,
                onClick: () => this.dam(),
                visible: this.state.usaPix ? true : false,
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Confirmar Pix",
                icon: "todo",
                width: 150,
                onClick: () => this.confirmarPix(),
                visible: this.state.usaPix ? true : false,
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Nota Fiscal",
                icon: "money",
                width: 150,
                onClick: this.documento,
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Recibo",
                icon: "doc",
                width: 150,
                onClick: this.reciboRetencao,
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Editar",
                icon: "edit",
                width: 150,
                onClick: this.editar,
              }}
            />
          </Toolbar>
          <br />
          <form>
            <Form formData={this.state} className="readOnlyBGless" colCount={2}>
              <GroupItem
                caption={"DADOS DA NOTA FISCAL AVULSA"}
                colSpan={2}
                colCount={6}
              >
                <SimpleItem
                  colSpan={1}
                  dataField={"sequencial"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Cód. Interno" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"statusProcessoStr"}
                  editorOptions={{ width: "100%", readOnly: true }}
                >
                  <Label text="Status Processo" />
                </SimpleItem>

                <SimpleItem
                  colSpan={4}
                  dataField={"chaveAcessoAdn"}
                  editorOptions={{ width: "100%", readOnly: true }}
                >
                  <Label text="Chave de Acesso" />
                </SimpleItem>



                <GroupItem colSpan={6} colCount={4}>
                  <SimpleItem
                    colSpan={6}
                    dataField={"codigoVerificacao"}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="Cód. Verificação" />
                  </SimpleItem>

                  <EmptyItem colSpan={3} />
                  <SimpleItem
                    colSpan={1}
                    dataField={"dataDeEmissao"}
                    editorType={"dxDateBox"}
                    editorOptions={{ width: "100%", readOnly: true }}
                  >
                    <Label text="Data de Emissão" />
                  </SimpleItem>

                  <SimpleItem
                    colSpan={1}
                    editorType={"dxDateBox"}
                    dataField={"dataDoServico"}
                    editorOptions={{ width: "100%", readOnly: true }}
                  >
                    <Label text="Data do Serviço" />
                  </SimpleItem>

                  <SimpleItem
                    colSpan={1}
                    dataField={"statusStr"}
                    editorOptions={{ width: "100%", readOnly: true }}
                  >
                    <Label text="Status" />
                  </SimpleItem>



                  <SimpleItem
                    colSpan={1}
                    dataField={"tributacaoIssStr"}
                    editorOptions={{ width: "100%", readOnly: true }}
                  >
                    <Label text="Tributação" />
                  </SimpleItem>
                </GroupItem>

                <SimpleItem
                  colSpan={4}
                  dataField={"prestador.nome"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Prestador" />
                </SimpleItem>

                <SimpleItem
                  colSpan={2}
                  dataField={"prestador.documentoFormatado"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Documento" />
                </SimpleItem>

                <SimpleItem
                  colSpan={4}
                  dataField={"tomador.nome"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Tomador" />
                </SimpleItem>

                <SimpleItem
                  colSpan={2}
                  dataField={"tomador.documentoFormatado"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Documento" />
                </SimpleItem>

                <SimpleItem
                  colSpan={6}
                  dataField={"servico.descricao"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Serviço" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <br />
            <h3>Títulos da Nota Fiscal</h3>
            <DataGrid
              dataSource={this.state._uiParcelas}
              showBorders={true}
              rowAlternationEnabled={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
            >
              <Column
                alignment={"center"}
                dataField={"sequencial"}
                caption={"DAM"}
                width={80}
              />

              <Column
                alignment={"center"}
                format={"00"}
                dataField={"receita.origem"}
                caption={"Imposto"}
                width={80}
              />

              <Column
                alignment={"center"}
                dataField={"dataDeVencimento"}
                caption={"Vencimento"}
                dataType="date"
                width={120}
              />

              <Column
                dataField={"valorTotal"}
                dataType={"number"}
                caption={"Valor (R$)"}
                format={uiInfo.formatoNumerico.n2}
                width={150}
              />

              <Column
                dataField={"situacaoPagto"}
                caption={"Situação"}
                width={200}
              />

              <Column dataField={"descricao"} caption={"Parcela"} />

              <Summary>
                <TotalItem
                  column="valorTotal"
                  summaryType="sum"
                  displayFormat={"Total (R$): {0}"}
                  valueFormat={uiInfo.formatoNumerico.n2}
                />
              </Summary>
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
            <br />
            <br />
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "inline-block",
                  marginRight: "10px",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Form formData={this.state}>
                  <GroupItem caption={"BAIXA MANUAL"} colSpan={1} colCount={4}>
                    <SimpleItem colSpan={2} dataField={"baixa.damSequencial"}>
                      <Label text="DAM" />
                    </SimpleItem>

                    <EmptyItem colSpan={2} />

                    <SimpleItem
                      colSpan={4}
                      dataField={"baixa.agenteRecebedorId"}
                      editorType={"dxSelectBox"}
                      editorOptions={this.agenteRecebedorOptions}
                    >
                      <Label text="Ag. Recebedor" />
                    </SimpleItem>

                    <SimpleItem
                      colSpan={2}
                      dataField={"baixa.dataPagto"}
                      dataType={"date"}
                      editorType={"dxDateBox"}
                      editorOptions={{ width: "100%", useMaskBehavior: true }}
                    >
                      <Label text="Dt. Pagamento" />
                    </SimpleItem>

                    <SimpleItem
                      colSpan={2}
                      dataField={"baixa.dataCredito"}
                      dataType={"date"}
                      editorType={"dxDateBox"}
                      editorOptions={{ width: "100%", useMaskBehavior: true }}
                    >
                      <Label text="Dt. Crédito" />
                    </SimpleItem>

                    <SimpleItem
                      colSpan={2}
                      dataField={"baixa.valorPago"}
                      editorType={"dxNumberBox"}
                      cssClass="box-n2"
                      editorOptions={{
                        format: uiInfo.formatoNumerico.n2,
                      }}
                    >
                      <Label text="Valor" />
                    </SimpleItem>

                    <EmptyItem colSpan={2} />

                    <EmptyItem />

                    <ButtonItem
                      buttonOptions={{
                        text: "REALIZAR BAIXA",
                        type: "success",
                        onClick: this.baixarParcela,
                        width: "100%",
                      }}
                      alignment={"center"}
                    />

                    <ButtonItem
                      buttonOptions={{
                        text: "EXCLUIR BAIXA",
                        type: "default",
                        onClick: this.excluirBaixa,
                        width: "100%",
                      }}
                      alignment={"center"}
                    />
                  </GroupItem>
                </Form>
              </div>
              <div
                style={{
                  display: "inline-block",
                  marginLeft: "10px",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Form
                  formData={this.state}
                  colCount={1}
                  className={"readOnlyBGless"}
                >
                  <GroupItem caption={"SITUAÇÃO"} colSpan={1} colCount={4}>
                    <SimpleItem
                      colSpan={4}
                      dataField={"_uiModificarSituacao.novaSituacao"}
                      editorType={"dxSelectBox"}
                      editorOptions={this.situacaoOptions}
                    >
                      <Label text="Nova Situação" />
                    </SimpleItem>

                    <SimpleItem
                      dataField={"_uiModificarSituacao.tipo"}
                      colSpan={4}
                      editorType={"dxSelectBox"}
                      editorOptions={this.tipoMudancaSituacaoOptions}
                    >
                      <Label text="Apllicação" />
                    </SimpleItem>

                    <SimpleItem
                      colSpan={4}
                      dataField={"_uiModificarSituacao.motivoId"}
                      editorType={"dxLookup"}
                      editorOptions={{
                        ...this.motivoSituacaoOptions,
                        readOnly:
                          this.state._uiModificarSituacao.novaSituacao === "N"
                            ? true
                            : false,
                      }}
                    >
                      <Label text="Motivo" />
                    </SimpleItem>

                    <EmptyItem colSpan={4} />
                    <EmptyItem colSpan={4} />

                    <EmptyItem />

                    <ButtonItem
                      colSpan={2}
                      buttonOptions={{
                        text: "MODIFICAR SITUAÇÃO",
                        type: "success",
                        onClick: this.modificarSituacao,
                        width: "100%",
                      }}
                      alignment={"center"}
                    />
                  </GroupItem>
                </Form>
              </div>
            </div>
          </form>

          <Popup
            visible={this.state._uiShowErrors}
            onHiding={() => this.setState({ _uiShowErrors: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title={"LOGS ADN"}
          >

            <ScrollView showScrollbar={"always"}>

              <DataGrid
                dataSource={this.state._uiErrors}
                showBorders={true}
                rowAlternationEnabled={true}
                columnAutoWidth={true}
                columnHidingEnabled={true}
                wordWrapEnabled={true} height={"90%"}
              >
                <Column
                  alignment={"Data/Hora"}
                  dataField={"dataHoraEnvio"}
                  dataType={"datetime"}
                  caption={"DAM"}
                  width={80}
                />

                <Column
                  alignment={"left"}
                  dataField={"mensagemUsuario"}
                  caption={"Erro"}
                />

                <Column
                  alignment={"left"}
                  dataField={"response"}
                  caption={"Resposta ADN/RFB"}
                />

                <Paging defaultPageSize={14} />

                <Pager showPageSizeSelector={true} allowedPageSizes={[14]} />
              </DataGrid>

            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ _uiShowErrors: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  baixarParcela() {
    const entidade = this.state.baixa;
    entidade.tipoBaixa = 1;
    entidade.prefeituraId = this.prefeituraId;
    api
      .post("dam/baixa_manual/", this.state.baixa)
      .then(() => {
        this.setState({
          baixa: {
            damSequencial: null,
            agenteRecebedorId: null,
            dataPagto: null,
            dataCredito: null,
            valorPago: null,
          },
        });
        this.atualizarTela();
      })
      .catch((error) => {
        ShowError(error.response.data);
      });
  }

  excluirBaixa() {

    console.log("state baixa", this.state);


    if (this.state.baixa == undefined || this.state.baixa.damSequencial == undefined || this.state.baixa.damSequencial == "") {
      ShowError("Informe o código do DAM");
      return;
    }


    var entidade = {
      tipoBaixa: 1,
      prefeituraId: this.prefeituraId,
      damSequencial: this.state.baixa.damSequencial,
    };

    api
      .post("dam/excluir_baixa_manual/", entidade)
      .then(() => {
        this.setState({
          baixa: {
            damSequencial: null,
            agenteRecebedorId: null,
            dataPagto: null,
            dataCredito: null,
            valorPago: null,
          },
        });
        this.atualizarTela();
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError(error.message);
        }
      });
  }

  modificarSituacao() {
    const entidade = {
      prefeituraId: this.prefeituraId,
      notaAvulsaSequencial: this.state.sequencial,
      tipo: this.state._uiModificarSituacao.tipo,
      novaSituacao: this.state._uiModificarSituacao.novaSituacao,
      motivoId: this.state._uiModificarSituacao.motivoId,
    };

    api
      .post("dam/mudar_situacao_nf_avulsa/", entidade)
      .then(() => {
        this.setState({
          _uiModificarSituacao: {
            tipo: null,
            novaSituacao: "N",
            motivoId: null,
          },
        });
        this.atualizarTela();
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError("Erro desconhecido");
        }
      });
  }

  editar() {
    abrirNotaAvulsa(this.props.history, this.state);
  }

  reciboRetencao() {
    imprimirReciboNotaAvulsa(this.state);
  }

  dam() {
    imprimirDamsNotaAvulsa(this.state);
  }

  async confirmarPix() {
    this.setState({ locadIndicatorVisivel: true, consultandoPagamento: true });
    api
      .get(
        `/nota_fiscal_avulsa/consultar_pagamento_pix_nfa/${this.prefeituraId}/${this.notaSequencial}`
      )
      .then(({ data }) => {
        if (this.state.consultandoPagamento) {
          const nfAvulsa = data.nf;
          if (nfAvulsa) {
            this.setState({ ...nfAvulsa, locadIndicatorVisivel: false });
          }
        }

      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError("Erro desconhecido");
        }
      });
  }

  documento() {
    imprimirNotaAvulsa(this.state);
  }

  finalizar() {

    this.setState({ locadIndicatorVisivel: true, loadIndicatorMessage: "Finalizando Nota Avulsa" });
    api
      .post(`nota_fiscal_avulsa/finalizar/${this.prefeituraId}/${this.notaSequencial}`)
      .then(() => {

        this.atualizarTela();
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError("Erro desconhecido");
        }
      })
      .finally(() => {
        this.setState({ locadIndicatorVisivel: false, loadIndicatorMessage: null });
      });
  }

  showErrors() {

    this.setState({ locadIndicatorVisivel: true, loadIndicatorMessage: "Buscando erros..." });

    api
      .get(`nota_fiscal_avulsa/erros/${this.prefeituraId}/${this.notaSequencial}`)
      .then((response) => {
        console.log("response", response);

        this.setState({ locadIndicatorVisivel: false, loadIndicatorMessage: null, _uiShowErrors: true, _uiErrors: response.data });



      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError("Erro desconhecido");
        }
      })
      .finally(() => {
        this.setState({ locadIndicatorVisivel: false, loadIndicatorMessage: null });
      });
  }
}
